module.exports = __webpack_public_path__ + "static/media/male.9a3a77b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/male.svg
// module id = 488
// module chunks = 0